import { render } from "./UserRegistrationPage.vue?vue&type=template&id=6be3616d&scoped=true"
import script from "./UserRegistrationPage.vue?vue&type=script&lang=js"
export * from "./UserRegistrationPage.vue?vue&type=script&lang=js"

import "./UserRegistrationPage.vue?vue&type=style&index=0&id=6be3616d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be3616d"]])

export default __exports__